export const getAddressSuggest = (data) => {
    return data;
};
